import store from 'store'

import conditionalFieldsSummary from 'ConditionalHelpers/summary'
import { checkEventAction } from 'ConditionalHelpers/rules'
import { getCurrentUserSelector } from 'selectors'

export const validate = (model, object) => {
  const storeState = store.getState()
  const rules = storeState.modern.currentAccount.conditional_fields
  const rulesDefaults = storeState.modern.currentAccount.conditional_fields_defaults
  const currentUser = getCurrentUserSelector(storeState)
  const isNewObject = object.id === undefined

  if (!rules || !rulesDefaults) return {}

  const filteredRules = rules.filter(rule => {
    return rule.event_model === model && checkEventAction(rule, isNewObject)
  })

  const filteredRulesDefaults = rulesDefaults.filter(rule => {
    return rule.event_model === model
  })

  return conditionalFieldsSummary([...filteredRulesDefaults, ...filteredRules], object, currentUser)
}

export default validate
